import React, { useEffect, useState } from 'react'
import { RxCrossCircled } from 'react-icons/rx';
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { makeAjax, respStatus, showMessage, url } from '../../../helpers/global_helper';
import { FiRefreshCcw } from 'react-icons/fi';

const Result = (props) => {
  const [colspan, setColspan] = useState(4);
  const [colokBebas2d, setColokBebas2d] = useState([]);
  const [colokNaga, setColokNaga] = useState([]);
  const [numberData, setNumberData] = useState([]);
  const [spinning, setSpinning] = useState(false);

  const getLotteryResultDetail = () => {
    const payload = {
      code: props.rowData.code,
      period: props.rowData.period,
      result: props.rowData.result,
      clicked_call: true
    };

    makeAjax(url.GP_API.getLotteryResultDetail, payload, url.GP_MS_EXT).then(
      (response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          showMessage(response);
          return;
        }
        setNumberData(response.data);
      }
    );

    setSpinning(true);
    setTimeout(() => {
      setSpinning(false);
    }, 1000);
  };

  useEffect(() => {
    getLotteryResultDetail();
  }, []);

  const generateUniqueCombinations = (digits, size, maxLimit) => {
    const results = new Set();
    const duplicates = [];
    let appendCount = 0;

    const backtrack = (path, reversePath) => {
      if (path.length === size) {
        const forward = path.join('');
        const reverse = reversePath.join('');
          
        // Pad both forward and reverse to maintain leading zeros
        const paddedForward = forward.padStart(size, '0');
        const paddedReverse = reverse.padStart(size, '0');
        
        // Compare as strings to keep leading zeros
        const first = paddedForward < paddedReverse ? paddedForward : paddedReverse;
        const second = paddedForward < paddedReverse ? paddedReverse : paddedForward;

        const combination = `${first} = ${second}`;
        if (!results.has(combination)) {
          results.add(combination);
        } else if (appendCount < maxLimit) {
          duplicates.push(combination);
          results.delete(combination);
          appendCount++;
        }
        return;
      }

      for (const digit of digits) {
        if (!path.includes(digit)) {
          path.push(digit);
          reversePath.unshift(digit); // Add to the start to build reverse simultaneously
          backtrack(path, reversePath);
          // Backtrack by removing last added digit
          path.pop();
          reversePath.shift();
          if (appendCount >= maxLimit) return; // Early exit if maxLimit is reached
        }
      }
    };

    backtrack([], []);
    return { results: Array.from(results), duplicates };
  };

  useEffect(() => {
    if (numberData) {
      if (numberData?.number_detail?.number) {
        const length = numberData.number_detail.number.length;
        setColspan(length === 6 || length === 5 ? length : 4);
      }

      const number = numberData?.number_detail?.number.slice(-4);
      if (number) {
        const max2DLimit = 8, max3DLimit = 12;
        const uniqueDigits = [...new Set(number.split(''))];

        const { duplicates: colokBebas2d } = generateUniqueCombinations(uniqueDigits, 2, max2DLimit);
        const { duplicates: colokNaga } = generateUniqueCombinations(uniqueDigits, 3, max3DLimit);
        console.log("colokBebas2d : ",colokBebas2d);
        console.log("colokNaga : ",colokNaga);
        setColokBebas2d(colokBebas2d);
        setColokNaga(colokNaga);
      }
    }
  }, [numberData?.number_detail?.number]);


  return (
    <>
      <div className='resultbg' id='popuptable'>

        <button onClick={() => getLotteryResultDetail()} style={{ cursor: 'pointer' }} className="refresh mb-2">
          <FiRefreshCcw className={spinning ? "spin" : ""} style={{ cursor: "pointer" }} /> &nbsp;
          {props.t('refresh')}
        </button>

        <table className="w-full border-collapse table-fixed">
          <thead className="text-white bg-brown-newtemplate-1">
            <tr className="head">
              <td rowspan="2" width="40%" className="border border-black-0" style={{ color: "#fff" }} >GAMES</td>
              {numberData?.number_detail && numberData?.number_detail?.number && (numberData?.number_detail?.number.length === 6 || numberData?.number_detail?.number.length === 5) ? (
                <>
                  <td colspan="2" className="border border-black-0 6d-column" ></td>
                </>
              ) : null}
              <td colspan="4" className="border border-black-0" style={{ color: "#fff" }} >ABCD, A=As, B=Kop, C=Kepala, D=Ekor</td>
            </tr>
            <tr>
              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length >= 6 ? (
                <>
                  <td className="border border-black-0 6d-column" style={{ color: "#fff" }}>6D</td>
                </>
              ) : null}
              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length >= 5 ? (
                <>
                  <td className="border border-black-0 6d-column" style={{ color: "#fff" }} >5D</td>
                </>
              ) : null}

              <td className="border border-black-0 " style={{ color: "#fff" }}>As</td>
              <td className="border border-black-0 " style={{ color: "#fff" }}>Kop</td>
              <td className="border border-black-0 " style={{ color: "#fff" }}>Kepala</td>
              <td className="border border-black-0 " style={{ color: "#fff" }}> Ekor </td>
            </tr>
          </thead>
          <tbody>
            {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length >= 6 ? (
              <>
                <tr className="6d-column">
                  <td className="border border-black-0">6D</td>
                  {
                    numberData.number_detail.number.split('').map((num, index) => (
                      <td key={index} className="border togel-6d-0 border-black-0">{num}</td>
                    ))
                  }
                </tr>
              </>
            ) : (null)}

            {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length >= 5 ? (
              <>
                <tr className="5d-column">
                  <td className="border border-black-0">5D</td>
                  <>
                    {numberData.number_detail.number.length >= 5 ? (
                      [...Array(numberData.number_detail.number.length - 5)].map((_, index) => (
                        <td key={index} className="border togel-6d-0 border-black-0">-</td>
                      ))
                    ) : (null)}

                    {numberData.number_detail.number.split('').slice(numberData.number_detail.number.length - 5).map((num, index) => (
                      <td key={index} className="border togel-6d-0 border-black-0">{num}</td>
                    ))}
                  </>
                </tr>
              </>
            ) : (null)}

            {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length >= 4 ? (
              <>
                <tr>
                  <td className="border border-black-0">4D</td>
                  {[...Array(numberData.number_detail.number.length - 4)].map((_, index) => (
                    <td key={index} className="border togel-6d-0 border-black-0">-</td>
                  ))}
                  {
                    numberData.number_detail.number.split('').slice(numberData.number_detail.number.length - 4).map((num, index) => (
                      <td key={index} className="border togel-6d-0 border-black-0">{num}</td>
                    ))
                  }
                </tr>
              </>
            ) : (null)}



            {numberData?.number_detail?.number && numberData?.number_detail?.number.length >= 4 ? (
              <>
                <tr>
                  <td className="border border-black-0">3D Depan</td>
                  {[...Array(numberData.number_detail.number.length - 4)].map((_, index) => (
                    <td key={index} className="border togel-6d-0 border-black-0">-</td>
                  ))}
                  {numberData.number_detail.number
                    .split('')
                    .slice(numberData.number_detail.number.length - 4, numberData.number_detail.number.length - 1)
                    .map((num, index) => (
                      <td key={index} className="border togel-6d-0 border-black-0">{num}</td>
                    ))
                  }
                  <td className="border togel-6d-0 border-black-0">-</td>
                </tr>
              </>
            ) : null}

            {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length >= 3 ? (
              <>
                <tr>
                  <td className="border border-black-0">3D Belakang</td>
                  {[...Array(numberData.number_detail.number.length - 3)].map((_, index) => (
                    <td key={index} className="border togel-6d-0 border-black-0">-</td>
                  ))}
                  {
                    numberData.number_detail.number.split('').slice(numberData.number_detail.number.length - 3).map((num, index) => (
                      <td key={index} className="border togel-6d-0 border-black-0">{num}</td>
                    ))
                  }
                </tr>
              </>
            ) : (null)}

            {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length >= 4 ? (
              <>
                <tr>
                  <td className="border border-black-0">2D Depan</td>
                  {[...Array(numberData.number_detail.number.length - 4)].map((_, index) => (
                    <td key={index} className="border togel-6d-0 border-black-0">-</td>
                  ))}
                  {
                    numberData.number_detail.number.split('').slice(numberData.number_detail.number.length - 4, numberData.number_detail.number.length - 2).map((num, index) => (
                      <td key={index} className="border togel-6d-0 border-black-0">{num}</td>
                    ))
                  }
                  <td className="border togel-6d-0 border-black-0">-</td>
                  <td className="border togel-6d-0 border-black-0">-</td>
                </tr>
              </>
            ) : null}

            {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length >= 4 ? (
              <>
                <tr>
                  <td className="border border-black-0">2D Tengah</td>
                  {[...Array(numberData.number_detail.number.length - 4)].map((_, index) => (
                    <td key={index} className="border togel-6d-0 border-black-0">-</td>
                  ))}
                  {numberData.number_detail.number
                    .split('')
                    .slice(numberData.number_detail.number.length - 4)
                    .map((num, index) => (
                      <td key={index} className="border togel-6d-0 border-black-0">
                        {index === 0 || index === 3 ? '-' : num}
                      </td>
                    ))}
                </tr>
              </>
            ) : null}



            {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length >= 2 ? (
              <>
                <tr>
                  <td className="border border-black-0">2D Belakang</td>
                  {[...Array(numberData.number_detail.number.length - 2)].map((_, index) => (
                    <td key={index} className="border togel-6d-0 border-black-0">-</td>
                  ))}
                  {
                    numberData.number_detail.number.split('').slice(numberData.number_detail.number.length - 2).map((num, index) => (
                      <td key={index} className="border togel-6d-0 border-black-0">{num}</td>
                    ))
                  }
                </tr>
              </>
            ) : (null)}

            <tr>
              <td className="border border-black-0">Colok Bebas</td>
              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length >= 4 ? (
                [...Array(numberData.number_detail.number.length - 4)].map((_, index) => (
                  <td key={index} className="border togel-6d-0 border-black-0">-</td>
                ))
              ) : null}

              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ? (
                numberData.number_detail.number.split('').slice(numberData.number_detail.number.length - 4).map((num, index) => (
                  <td key={index} className="border togel-6d-0 border-black-0">{num}</td>
                ))
              ) : (
                <>

                  {numberData?.number_detail && numberData?.number_detail?.number &&
                    [...Array(numberData.number_detail.number.length)].map((_, index) => (
                      <td key={index} className="border togel-6d-0 border-black-0">-</td>
                    ))
                  }
                </>
              )}

            </tr>
            <tr>
              <td rowspan="2" className="border border-black-0">Kombinasi</td>
              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length === 6 ? (
                [...Array(2)].map((_, index) => (
                  <td key={index} className="border togel-6d-0 border-black-0">-</td>
                ))
              ) : (null)}

              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length === 5 ? (
                [...Array(1)].map((_, index) => (
                  <td key={index} className="border togel-6d-0 border-black-0">-</td>
                ))
              ) : (null)}
              {/* {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ? numberData?.number_detail?.as50_temp.split('#')[0] : (
                <>

                  <td className="border togel-6d-0 border-black-0" >-</td>
                </>
              )} */}
              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ?
                <>

                  <td className="border togel-6d-0 border-black-0">{numberData?.number_detail?.as50_temp?.split('#')[0]}</td>
                </> : (
                  <>

                    <td className="border togel-6d-0 border-black-0">-</td>
                  </>
                )}

              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ?
                <>

                  <td className="border togel-6d-0 border-black-0">{numberData.number_detail.kop50_temp.split('#')[0]}</td>
                </> : (
                  <>

                    <td className="border togel-6d-0 border-black-0">-</td>
                  </>
                )}

              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ?
                <>

                  <td className="border togel-6d-0 border-black-0">{numberData?.number_detail?.kepala50_temp?.split('#')[0]}</td>
                </> : (
                  <>

                    <td className="border togel-6d-0 border-black-0">-</td>
                  </>
                )}

              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ?
                <>

                  <td className="border togel-6d-0 border-black-0">{numberData.number_detail.ekor50_temp.split('#')[0]}</td>
                </> : (
                  <>

                    <td className="border togel-6d-0 border-black-0">-</td>
                  </>
                )}
            </tr>

            <tr>
              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length === 6 ? (
                [...Array(2)].map((_, index) => (
                  <td key={index} className="border togel-6d-0 border-black-0">-</td>
                ))
              ) : (null)}

              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length === 5 ? (
                [...Array(1)].map((_, index) => (
                  <td key={index} className="border togel-6d-0 border-black-0">-</td>
                ))
              ) : (null)}

              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ?
                <>

                  <td className="border togel-6d-0 border-black-0">{numberData?.number_detail?.as50_temp?.split('#')[1]}</td>
                </> : (
                  <>

                    <td className="border togel-6d-0 border-black-0">-</td>
                  </>
                )}
              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ?
                <>

                  <td className="border togel-6d-0 border-black-0">{numberData.number_detail.kop50_temp.split('#')[1]}</td>
                </> : (
                  <>

                    <td className="border togel-6d-0 border-black-0">-</td>
                  </>
                )}

              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ?
                <>

                  <td className="border togel-6d-0 border-black-0">{numberData?.number_detail?.kepala50_temp?.split('#')[1]}</td>
                </> : (
                  <>

                    <td className="border togel-6d-0 border-black-0">-</td>
                  </>
                )}

              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ?
                <>

                  <td className="border togel-6d-0 border-black-0">{numberData.number_detail.ekor50_temp.split('#')[1]}</td>
                </> : (
                  <>

                    <td className="border togel-6d-0 border-black-0">-</td>
                  </>
                )}
            </tr>
            <tr>
              <td className="border border-black-0">Colok Jitu</td>
              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length >= 4 ? (
                [...Array(numberData.number_detail.number.length - 4)].map((_, index) => (
                  <td key={index} className="border togel-6d-0 border-black-0">-</td>
                ))
              ) : null}

              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ? (
                numberData.number_detail.number.split('').slice(numberData.number_detail.number.length - 4).map((num, index) => (
                  <td key={index} className="border togel-6d-0 border-black-0">{num}</td>
                ))
              ) : (
                <>
                  {numberData?.number_detail && numberData?.number_detail?.number &&
                    [...Array(numberData.number_detail.number.length)].map((_, index) => (
                      <td key={index} className="border togel-6d-0 border-black-0">-</td>
                    ))
                  }
                </>
              )}

            </tr>
            <tr>
              <td rowspan="2" className="border border-black-0">50-50</td>
              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length === 6 ? (
                [...Array(2)].map((_, index) => (
                  <td key={index} className="border togel-6d-0 border-black-0">-</td>
                ))
              ) : (null)}

              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length === 5 ? (
                [...Array(1)].map((_, index) => (
                  <td key={index} className="border togel-6d-0 border-black-0">-</td>
                ))
              ) : (null)}
              {/* {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ? numberData?.number_detail?.as50_temp?.split('#')[0] : (
                <>

                  <td className="border togel-6d-0 border-black-0">-</td>
                </>
              )} */}
              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ?
                <>

                  <td className="border togel-6d-0 border-black-0">{numberData?.number_detail?.as50_temp?.split('#')[0]}</td>
                </> : (
                  <>

                    <td className="border togel-6d-0 border-black-0">-</td>
                  </>
                )}

              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ?
                <>

                  <td className="border togel-6d-0 border-black-0">{numberData?.number_detail?.kop50_temp?.split('#')[0]}</td>
                </> : (
                  <>

                    <td className="border togel-6d-0 border-black-0">-</td>
                  </>
                )}

              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ?
                <>

                  <td className="border togel-6d-0 border-black-0">{numberData?.number_detail?.kepala50_temp?.split('#')[0]}</td>
                </> : (
                  <>

                    <td className="border togel-6d-0 border-black-0">-</td>
                  </>
                )}

              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ?
                <>

                  <td className="border togel-6d-0 border-black-0">{numberData?.number_detail?.ekor50_temp?.split('#')[0]}</td>
                </> : (
                  <>

                    <td className="border togel-6d-0 border-black-0">-</td>
                  </>
                )}

            </tr>
            <tr>
              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length === 6 ? (
                [...Array(2)].map((_, index) => (
                  <td key={index} className="border togel-6d-0 border-black-0">-</td>
                ))
              ) : (null)}

              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length === 5 ? (
                [...Array(1)].map((_, index) => (
                  <td key={index} className="border togel-6d-0 border-black-0">-</td>
                ))
              ) : (null)}
              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ?
                <>

                  <td className="border togel-6d-0 border-black-0">{numberData?.number_detail?.as50_temp?.split('#')[1]}</td>
                </> : (
                  <>

                    <td className="border togel-6d-0 border-black-0">-</td>
                  </>
                )}
              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ?
                <>

                  <td className="border togel-6d-0 border-black-0">{numberData?.number_detail?.kop50_temp.split('#')[1]}</td>
                </> : (
                  <>

                    <td className="border togel-6d-0 border-black-0">-</td>
                  </>
                )}

              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ?
                <>

                  <td className="border togel-6d-0 border-black-0">{numberData?.number_detail?.kepala50_temp?.split('#')[1]}</td>
                </> : (
                  <>

                    <td className="border togel-6d-0 border-black-0">-</td>
                  </>
                )}

              {numberData?.number_detail && numberData?.number_detail?.number && numberData.number_detail?.number.length !== 0 ?
                <>

                  <td className="border togel-6d-0 border-black-0">{numberData.number_detail.ekor50_temp.split('#')[1]}</td>
                </> : (
                  <>

                    <td className="border togel-6d-0 border-black-0">-</td>
                  </>
                )
              }

            </tr>
            <tr>
              <td className="border border-black-0">50-50 2D</td>
              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ?
                <>
                  <td className="border  border-black-0" colspan={colspan}>{numberData.number_detail.fiftyFifty2D}</td>
                </> : (
                  <>
                    <td className="border  border-black-0" colspan={colspan}>-</td>
                  </>
                )
              }
            </tr>
            <tr className="head">
              <td colspan={colspan} width="100%" className="border border-black-0 bg-brown-newtemplate-1" >&nbsp;</td>
              <td colspan={1} width="100%" className="border border-black-0 bg-brown-newtemplate-1" >&nbsp;</td>
            </tr>
            <tr>
              <td rowspan="2" className="border border-black-0">Colok Bebas 2D</td>
              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length === 6 ? (
                [...Array(2)].map((_, index) => (
                  <td key={index} className="border border-black-0 6d-column">-</td>
                ))
              ) : (null)}

              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length === 5 ? (
                [...Array(1)].map((_, index) => (
                  <td key={index} className="border border-black-0 6d-column">-</td>
                ))
              ) : (null)}

              {[...colokBebas2d.slice(0, 4)].map((num, index) => (
                <td key={index} className="border  border-black-0">{num}</td>
              ))}


              {[...Array(4 - colokBebas2d.slice(0, 4).length)].map((_, index) => (
                <td key={index} className="border border-black-0">&nbsp;</td>
              ))}

            </tr>
            <tr>
              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length === 6 ? (
                [...Array(2)].map((_, index) => (
                  <td key={index} className="border border-black-0 6d-column">-</td>
                ))
              ) : (null)}

              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length === 5 ? (
                [...Array(1)].map((_, index) => (
                  <td key={index} className="border border-black-0 6d-column">-</td>
                ))
              ) : (null)}

              {[...colokBebas2d.slice(4, 8)].map((num, index) => (
                <td key={index} className="border  border-black-0">{num}</td>
              ))}

              {[...Array(4 - colokBebas2d.slice(4, 8).length)].map((_, index) => (
                <td key={index} className="border border-black-0">&nbsp;</td>
              ))}

            </tr>
            <tr>
              <td rowspan="3" className="border border-black-0">Colok Naga</td>
              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length === 6 ? (
                [...Array(2)].map((_, index) => (
                  <td key={index} className="border border-black-0 6d-column">-</td>
                ))
              ) : (null)}

              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length === 5 ? (
                [...Array(1)].map((_, index) => (
                  <td key={index} className="border border-black-0 6d-column">-</td>
                ))
              ) : (null)}

              {[...colokNaga.slice(0, 4)].map((num, index) => (
                <td key={index} className="border  border-black-0">{num}</td>
              ))}

              {[...Array(4 - colokNaga.slice(0, 4).length)].map((_, index) => (
                <td key={index} className="border border-black-0">&nbsp;</td>
              ))}

            </tr>
            <tr>
              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length === 6 ? (
                [...Array(2)].map((_, index) => (
                  <td key={index} className="border border-black-0 6d-column">-</td>
                ))
              ) : (null)}

              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length === 5 ? (
                [...Array(1)].map((_, index) => (
                  <td key={index} className="border border-black-0 6d-column">-</td>
                ))
              ) : (null)}

              {[...colokNaga.slice(4, 8)].map((num, index) => (
                <td key={index} className="border  border-black-0">{num}</td>
              ))}

              {[...Array(4 - colokNaga.slice(4, 8).length)].map((_, index) => (
                <td key={index} className="border border-black-0">&nbsp;</td>
              ))}

            </tr>
            <tr>
              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length === 6 ? (
                [...Array(2)].map((_, index) => (
                  <td key={index} className="border border-black-0 6d-column">-</td>
                ))
              ) : (null)}

              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length === 5 ? (
                [...Array(1)].map((_, index) => (
                  <td key={index} className="border border-black-0 6d-column">-</td>
                ))
              ) : (null)}

              {[...colokNaga.slice(8, 12)].map((num, index) => (
                <td key={index} className="border  border-black-0">{num}</td>
              ))}

              {[...Array(4 - colokNaga.slice(8, 12).length)].map((_, index) => (
                <td key={index} className="border border-black-0">&nbsp;</td>
              ))}

            </tr>
            <tr>
              <td className="border border-black-0">Shio</td>
              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ?
                <>

                  <td className="border border-black-0" colspan={colspan}>{numberData.number_detail.shio}</td>
                </> : (
                  <>

                    <td className="border border-black-0" colspan={colspan}>-</td>
                  </>
                )
              }
            </tr>
            <tr>
              <td className="border border-black-0">Silang Homo</td>
              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ?
                <>

                  <td className="border border-black-0" colspan={colspan}>{numberData.number_detail.silangHomo}</td>
                </> : (
                  <>

                    <td className="border border-black-0" colspan={colspan}>-</td>
                  </>
                )
              }
            </tr>
            <tr>
              <td className="border border-black-0">Tengah Tepi</td>
              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ?
                <>

                  <td className="border border-black-0" colspan={colspan}>{numberData.number_detail.tengahTepi}</td>
                </> : (
                  <>

                    <td className="border border-black-0" colspan={colspan}>-</td>
                  </>
                )
              }
            </tr>
            <tr>

              <td className="border border-black-0">Kembang Kempis Kembar</td>
              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ?
                <>

                  <td className="border border-black-0" colspan={colspan}>{numberData.number_detail.kembangKempis}</td>
                </> : (
                  <>

                    <td className="border border-black-0" colspan={colspan}>-</td>
                  </>
                )
              }
            </tr>
            <tr>
              <td className="border border-black-0">Dasar</td>
              {numberData?.number_detail && numberData?.number_detail?.number && numberData?.number_detail?.number.length !== 0 ?
                <>

                  <td className="border border-black-0" colspan={colspan}>{numberData.number_detail.dasar_temp}</td>
                </> : (
                  <>

                    <td className="border border-black-0" colspan={colspan}>-</td>
                  </>
                )
              }
            </tr>
          </tbody>
        </table>
      </div>
    </>
  )
}

Result.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(Result);
